import React from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Table, NavLinkButton } from '@shared/components/bootstrap';

import { Panel } from '@admin/components/helpers/panel';
import { Permission } from '@admin/components/helpers/permission';
import { Spinner } from '@admin/components/spinner';
import { useTitle } from '@admin/hooks/use_title';
import { HIRING } from '@admin/libraries/access_control_catalog.generated';
import { client } from '@admin/libraries/apollo';
import { useHiringJobListQuery } from '@admin/schema';

export const HiringJobList: React.FC = () => {
  useTitle('Hiring | Roles');
  const { data, loading } = useHiringJobListQuery({ client });

  return (
    <Panel>
      <Table responsive striped>
        <thead>
          <tr>
            <th>Title</th>
            <th>Field</th>
            <th>Warehouse</th>

            <th className="text-right">
              <Permission resource={HIRING.resource} action={HIRING.actions.update} denied={null}>
                <NavLinkButton to="/hiring/roles/new" kind="mint">
                  <FontAwesomeIcon icon={faPlus} /> New
                </NavLinkButton>
              </Permission>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.hiringJobs.map((job) => (
            <tr key={job.id}>
              <td>{job.title}</td>
              <td>{job.field ? 'Yes' : 'No'}</td>
              <td>{job.warehouse ? 'Yes' : 'No'}</td>

              <td className="text-right">
                <Permission resource={HIRING.resource} action={HIRING.actions.update} denied={null}>
                  <NavLinkButton to={`/hiring/roles/${job.id}/edit`} kind="primary">
                    Edit
                  </NavLinkButton>
                </Permission>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {loading && <Spinner />}
    </Panel>
  );
};
